import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IndiceReajusteModel } from 'app/model/cliente/indicereajuste.model';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class IndicereajusteService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient: HttpClient) { }

  getIndicesReajuste(): Observable<ResponsePageable>{
    return this.httpClient.get<ResponsePageable>(this.apiURL + '/view/listar-indice', this.httpOptions);
  }

  getPageIndiceReajuste(page, size): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + `/view/listar-indice?page=${page}&size=${size}`, this.httpOptions);
  }

  postIndiceReajuste(indiceReajuste: IndiceReajusteModel): Observable<IndiceReajusteModel>{
    return this.httpClient.post<IndiceReajusteModel>(this.apiURL + '/new/adicionar-indice', indiceReajuste, this.httpOptions);
  }

  deleteIndiceReajuste(id: any){
    const headers = new HttpHeaders()
      .set('ticket', sessionStorage.getItem('ticket-ECM'))
      .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.get(this.apiURL + '/delete/deletar-indice/' + id , { headers, responseType: 'text' })
  }

  putIndiceReajuste(indiceReajuste: IndiceReajusteModel): Observable<IndiceReajusteModel>{
    return this.httpClient.put<IndiceReajusteModel>(this.apiURL + '/edit/editar-indice', indiceReajuste, this.httpOptions);
  }

}



// WEBPACK FOOTER //
// /app/src/app/service/cliente/indicereajuste.service.ts